import React from "react";
import styled, { ThemeProvider } from "styled-components";
import Modal from "react-modal";

import Menu from "../components/Menu";
import Head from "../components/Head";
import Banner from "../components/Banner";
import { theme } from "../styles/theme";
import media from "../styles/media";
import fondo from "../assets/images/patron-fondo.jpg";
import logoSvg from "../assets/images/logo-diners-blanco.svg";
import logo from "../assets/images/diners-club-logo.png";
import closeIco from "../assets/images/cerrarModal.png";

import "bootstrap/dist/css/bootstrap.min.css";

const GeneralContainer = styled.div`
  background: url(${fondo});
  font-size: 16px;
  text-align: justify;

  ${media.md`
    padding: 0 !important;
   
  `};

`;

const Header = styled.div`


  & .row {
    background-color: #202122;
    padding: 20px 40px;
    color: #fff;
    ${media.sm`
      & img {
        height: 35px;
      }
    `};
  }
  ul li:first-child{
    border-left: none;
    vertical-align: sub;
    padding-left: 0;
    padding-right: 40px;
    ${media.md`
      padding-right: 0;
    `};
  }
   ul li{
    font-size: 25px; 
    text-transform: uppercase; 
    border-left: solid 1px #fff;
    padding-left: 40px;
    letter-spacing: 5px;

    ${media.md`
      border-left: none;
      padding-left: 0;
    `};
   }

   & .list-inline{
     margin-bottom: 0;
   }
`;

const Footer = styled.div`
  & .row {
    text-align: center;
    background-color: ${theme.white};
    color: #202122;
    font-size: 16px;
    padding-left: 10px;

    & .footer-content{
      display: table-cell;
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }


`;

const ModalContent = styled.div`
  text-align: justify;
  color: ${theme.black};
  font-size: 12px;

  .title {
    color: ${theme.darkBlue};
    font-size: 15px;
    font-weight: bold;
  }
`;
const CloseButton = styled.button`
  position: absolute;
  top: -20px;
  right: -30px;
  background: none;
  border: none;
`;
export default class Template extends React.Component {
  state = {
    isModalOpen: false,
    actualYear: new Date()
  };

  handleModalShow = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen });
    document.documentElement.style.overflow = !this.state.isModalOpen
      ? "hidden"
      : "";
  };

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)"
      },
      content: {
        position: "relative",
        top: "30%",
        width: "540px",
        margin: "0 auto",
        overflow: "initial",
        padding: "20px 30px"
      }
    };

    return (
      <ThemeProvider theme={theme}>
        <GeneralContainer className="container-fluid">
          <Head title="Diners Club Internacional - Impuestos" />
          <Header className="container">
            <div className="row">
              <div className="col-sm-12 text-center">
              <ul className="list-inline">
                    <li>
                        CORPORATE
                    </li>
                    <li>        
                      <img
                        src={logoSvg}
                        alt="Logo Diners"
                        onError={e => {
                          e.target.src = logo;
                        }}
                        height="40"
                      />
                    </li>
                </ul>
               
              </div>
            </div>
          </Header>
          <div className="container">
            <Banner
              banner={this.props.banner}
              icon={this.props.icon}
              title={this.props.title}
              subtitle={this.props.subtitle}
           />

            <div className="row">
              <Menu active={this.props.active} />
            </div>
            {this.props.children({ handleModalShow: this.handleModalShow })}
          </div>
          <Modal
            isOpen={this.state.isModalOpen}
            style={modalStyle}
            onRequestClose={this.handleModalShow}
            ariaHideApp={false}
          >
            <div className="row">
              <ModalContent className="col-md-12">
                <p className="title">
                  Realice transacciones seguras sin necesidad de memorizar su
                  clave.
                </p>
                <p>
                  Ahora gracias a la <strong>CLAVE TEMPORAL</strong> de compras,
                  Usted podrá realizar transacciones rápidas y seguras. Recibirá
                  una clave diferente para cada transacción a su{" "}
                  <strong>CELULAR</strong> o a su{" "}
                  <strong>CORREO ELECTRÓNICO</strong> registrado.
                </p>
                <p>
                  Para utilizar este servicio debe actualizar sus datos llamando
                  a nuestro <strong>Call Center 1800 DINERS (346377).</strong>
                </p>
              </ModalContent>
            </div>
            <CloseButton onClick={this.handleModalShow}>
              <img src={closeIco} alt="Cerrar" />
            </CloseButton>
          </Modal>
          <Footer className="container">
            <div className="row">
              <div className="col-md-12 footer-content">
                &copy; {this.state.actualYear.getFullYear()} Diners Club del
                Ecuador. Todos los derechos reservados.
              </div>
            </div>
          </Footer>
        </GeneralContainer>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/templates/template.js